module.exports = __webpack_public_path__ + "img/PG.9c544b34.png";